import React from "react";
import "./Summary.css";

const Summary = () => {
  return (
    <div className="summary">
      <div className="wrapper">
        <div className="summary-intro-heading">
          <h2>Streszczenie</h2>
        </div>
      </div>
      <div className="summary-specialization">
        <h3>Akt I</h3>
        <p>
          Jest listopadowa noc roku tysiąc dziewięćsetnego. Akcja dramatu
          rozgrywa się w&nbsp;izbie wiejskiej chaty, w&nbsp;której słychać
          dźwięki weselnej muzyki i&nbsp;gwar toczących się za&nbsp;ścianą
          rozmów. W&nbsp;scenie pierwszej odbywa się rozmowa
          <b> Dziennikarza</b> z&nbsp;<b>Czepcem</b>, który stara się zmusić
          przybysza z&nbsp;miasta do dostrzeżenia w&nbsp;chłopach ludzi godnych
          uwagi, z&nbsp;których wywodził się przecież <b>Głowacki</b>. Według
          niego chłopi są ciekawi wiadomości ze świata i&nbsp;każdego dnia
          czytają gazety. <b>Dziennikarz</b> jest znudzony polityką
          i&nbsp;miejskim życiem. Pragnie rozkoszować się spokojem wsi.
        </p>
        <br />
        <p>
          Kolejne sceny przybliżają postacie <b>Zosi</b> i <b>Haneczki</b> –
          młodych panien, pełnych radości życia i&nbsp;skorych do tańców;
          <b> Radczyni</b> – kobiety wyniosłej, pobłażliwej dla ludu, lecz
          jednocześnie przekonanej o&nbsp;swej wyższości; <b>Jaśka</b> i&nbsp;
          <b> Kaspra</b>– wesołych chłopaków ze&nbsp;wsi; starej <b>Kliminy</b>,
          lubiącej zabawę i&nbsp;chętnej do swatania młodych;
          <b> Pana Młodego</b>, cieszącego się własnym szczęściem
          i&nbsp;zachwyconego urodą wybranki serca oraz
          <b> Panny Młodej</b> – dziewczyny rozsądnej, naiwnej i&nbsp;
          prostolinijnej.
          <b> Poeta</b>, znużony powodzeniem u&nbsp;kobiet oraz pełen niewiary
          w&nbsp;życie i&nbsp;sztukę, flirtuje z&nbsp;<b>Maryną</b>.
          W&nbsp;pewnym momencie zjawia się
          <b> Żyd</b>, dzierżawca pobliskiej karczmy. W&nbsp;rozmowie z&nbsp;
          <b>Panem Młodym</b> uwidacznia różnice między poszczególnymi grupami
          społecznymi, a&nbsp;także zarzuca młodzieńcowi, iż zanadto zachwyca
          się wiejskimi zwyczajami, a&nbsp;przecież następnego dnia zrzuci
          chłopski strój.
        </p>
        <br />
        <p>
          <b>Pan Młody</b> nie kryje swojego zauroczenia żoną – dziewczyną
          z&nbsp;prostego ludu, przy której inne panny wydają mu się przeciętne.
          Do izby weselnej wchodzi córka <b>Żyda</b>, <b>Rachela</b>.
          <b> Pan Młody </b>
          jest zachwycony wiejskim życiem, czuje się tu zdrowszym. Jest
          przekonany, że pewnego dnia napisze poemat o&nbsp;życiu na wsi.
          Obecność
          <b> Racheli</b>, rozmiłowanej w&nbsp;poezji i&nbsp;niezwykle
          uduchowionej, sprawia, iż goście weselni zaczynają rozmawiać
          o&nbsp;sztuce i&nbsp;twórczych tęsknotach. <b>Poeta</b> pragnie
          napisać dramat, rozmawia z&nbsp;<b>Gospodarzem</b> o&nbsp;roli
          artysty. Ich dialog przerywa pojawienie się
          <b> Czepca i&nbsp;Ojca</b>. <b>Poeta</b> określa siebie mianem
          „żurawca”, który jedynie przelotem bywa w&nbsp;kraju. Chłopi uznają,
          że&nbsp;mężczyzna nie jest szczęśliwy, a&nbsp;<b>Czepiec</b> radzi,
          aby poślubił dziewczynę z&nbsp;ludu, która da mu dużo szczęścia.
        </p>
        <br />
        <p>
          Następuje kłótnia o&nbsp;dług między <b>Czepcem</b> a&nbsp;
          <b>Żydem</b>, do której przyłącza się <b>Ksiądz</b>, upominając się
          o&nbsp;należność za&nbsp;dzierżawę karczmy. <b>Gospodarz </b>
          przypomina im krwawą rzeź, jakiej dokonali przed laty na szlachcie
          chłopi. <b>Pan Młody</b> wyznaje, że zna to wydarzenie
          z&nbsp;opowieści, lecz nie chce o&nbsp;nim myśleć, aby nie niszczyć
          swoich wyobrażeń o&nbsp;polskiej wsi. Dodaje, że szlachta zapomniała
          już o&nbsp;krzywdzie i&nbsp;teraz brata się z&nbsp;ludem, strojąc się
          w&nbsp;pawie pióra. W&nbsp;końcowej scenie <b>Poeta</b> ulega sugestii
          <b> Racheli</b> i&nbsp;prosi nowożeńców, aby zaprosili na wesele
          stojącego w&nbsp;sadzie <b>chochoła</b>. Młoda para, śmiejąc się
          i&nbsp;żartując, zaprasza razem z&nbsp;<b>Chochołem</b> każdego, kogo
          zechce przyprowadzić, by wespół z&nbsp;nimi cieszył się ich
          szczęściem.
        </p>
        <br />
        <h3>Akt II</h3>
        <p>
          W&nbsp;pustej izbie siedzi <b>Isia</b>, córka <b>Gospodarzy</b>, który
          usypia młodsze dziecko. Wybija północ i&nbsp;do pomieszczenia wchodzi
          <b> Chochoł</b>. Dziewczyna stara się przegnać niespodziewanego
          gościa. Po chwili do izby wchodzi <b>Marysia</b> z&nbsp;mężem
          <b>Wojtkiem</b>. Po ich rozmowie kobiecie ukazuje się <b>Widmo</b>,
          w&nbsp;którym rozpoznaje zmarłego przed laty narzeczonego.
          <b> Dziennikarzowi</b> ukazuje się
          <b> Stańczyk</b>. Spotkanie to burzy spokój mężczyzny, przypominając
          mu o&nbsp;niewoli narodowej i&nbsp;niemocy podjęcia walki
          narodowowyzwoleńczej. Do
          <b> Poety</b> przychodzi <b>Rycerz</b>, symbolizujący minioną chwałę
          i&nbsp; siłę narodu. Przed <b>Panem Młodym</b> staje
          <b> zjawa Hetmana Branickiego</b>, uważanego za&nbsp;symbol narodowej
          zdrady i&nbsp;szlacheckiego warcholstwa. <b>Dziadowi</b> ukazuje się
          <b> Upiór Szeli</b> – chłopskiego przywódcy krwawych rzezi
          galicyjskich z&nbsp;roku 1846.
        </p>
        <br />
        <p>
          Rozmowy weselników z&nbsp;przybyszami z&nbsp;zaświatów odkrywają ich
          marzenia, lęki oraz przypominają o&nbsp;bolesnych wydarzeniach
          z&nbsp;przeszłości. Na dziedziniec przed chatę wjeżdża
          <b> Wernyhora</b>, który przybywa do
          <b> Gospodarza</b> z&nbsp;rozkazem, aby rozesłać wici, wzywające lud
          do powstania. <b>Gospodarz</b> otrzymuje odpowiednie wskazówki i&nbsp;
          <b>złoty róg</b>, którego dźwięk ma w&nbsp;odpowiedniej chwili
          rozbudzić w&nbsp;sercach ludzi wolę walki. Zmęczony mężczyzna
          przekazuje róg
          <b> Jaśkowi</b>, nakazując mu wezwanie wszystkich chłopów, aby
          uzbrojeni stawili się o&nbsp;świcie przed kaplicą. <b>Jasiek </b>
          wybiega z izby, a&nbsp;<b>Gospodarz</b> dostaje od <b>Staszka </b>
          znalezioną przez niego <b>złotą podkowę</b>, która jest dla niego
          dowodem wizyty
          <b> Wernyhory</b>.
        </p>
        <br />
        <h3>Akt III</h3>
        <p>
          Zbliża się ranek, goście weselni są już zmęczeni całonocną zabawą
          i&nbsp; tańcami. W&nbsp;izbie zjawia się pijany <b>Nos</b>, szukający
          zapomnienia w&nbsp;alkoholu. <b>Panna Młoda</b> opowiada
          <b> Poecie</b> sen, w&nbsp;którym diabły wiozły ją w&nbsp;złotej
          karecie do Polski. Dziewczyna dopytuje się, gdzie jest Polska.
          Mężczyzna wyjaśnia, że nie znajdzie tego kraju, choćby szukała po
          całym świecie, ale odnajdzie go w&nbsp;swoim sercu. Do
          <b> Czepca</b> podchodzi <b>Kuba</b> i&nbsp;wspomina o&nbsp;nocnej
          wizycie
          <b> Wernyhory</b> i&nbsp;<b>złotej podkowie</b>, którą
          <b> Gospodyni </b>
          schowała w&nbsp;skrzyni. <b>Czepiec</b>, który nie wierzy
          w&nbsp;opowieść parobka, stara się obudzić <b>Gospodarza</b>. Kiedy to
          mu się nie udaje, sprowadza uzbrojonych chłopów.
        </p>
        <br />
        <p>
          Przebudzony <b>Gospodarz</b> nie pamięta nocnych wydarzeń. Rozgniewany
          <b> Czepiec</b> grozi, że jeśli panowie nie przyłączą się do nich, to
          chłopi rozprawią się z&nbsp;nimi za pomocą kos. <b>Pan Młody</b> nie
          słucha
          <b> Czepca</b> i&nbsp;zachwyca się pięknem przyrody o&nbsp;świcie. Nie
          zwraca też uwagi na ostrzeżenie chłopa, że zbliża się pora,
          w&nbsp;której powinni oczekiwać obiecanego im znaku. <b>Gospodarz </b>
          nagle przypomina sobie swoją rozmowę z&nbsp;<b>Wernyhorą</b>. Wszyscy
          zebrani odczuwają podniecenie, słyszą wrzawę i&nbsp;dostrzegają dziwne
          znaki na niebie. Oczekują na odpowiedni znak.
        </p>
        <br />
        <p>
          W&nbsp;oddali słychać tętent końskich kopyt. Zebrani w&nbsp;izbie
          ludzie nieruchomieją, trzymając w&nbsp;dłoniach kosy i&nbsp;szable,
          zdjęte ze&nbsp;ścian. Do pomieszczenia wbiega <b>Jasiek</b>.
          Zaskoczony niezwykłym widokiem, przypomina sobie, że miał zadąć
          w&nbsp;<b>złoty róg</b>. Z przerażeniem stwierdza, że zgubił
          powierzony mu przez <b>Gospodarza</b> przedmiot. Za&nbsp;chłopakiem do
          izby wchodzi <b>Chochoł</b>. Uświadamia
          <b> Jaśkowi</b>, iż zgubił róg w&nbsp;momencie, kiedy schylił się po
          <b> czapkę z&nbsp;pawimi piórami</b>. <b>Jasiek</b> bezskutecznie
          usiłuje zbudzić ludzi, zebranych w&nbsp;izbie. <b>Chochoł </b>
          nakazuje mu, aby wyjął z&nbsp;ich rąk szable i&nbsp;kosy. Zaczyna grać
          na skrzypcach, a&nbsp;ludzie tańczą w&nbsp;rytm chocholego śpiewu.
        </p>
        <br />
        <p>
          <em>klp.pl/wesele/ser-147.html</em>
        </p>
      </div>
    </div>
  );
};

export default Summary;
